// extracted by css-extract-rspack-plugin
export default {"unsatisfiedIcon":"ProofOfPresenceSection-module__unsatisfiedIcon__h8y1L","satisfiedIcon":"ProofOfPresenceSection-module__satisfiedIcon__V8sBG"};